export default __webpack_public_path__ + "static/media/outer-corners-rounded.adb0743f.webp";